const Card = ({ children, backgroundColour, fgColour }) => {

  var styles = {
    card: {
      backgroundColor: backgroundColour,
      color: fgColour,
    },
  }


  return (
    <div className="back google-card" style={styles.card} >
      {children}
    </div>
  )
}

export default Card